import { render, staticRenderFns } from "./InfoXboxOne.vue?vue&type=template&id=40692da4"
import script from "./InfoXboxOne.vue?vue&type=script&lang=js"
export * from "./InfoXboxOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports